/**
 * External dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import {BrowserRouter as Router, Route, Switch,} from "react-router-dom";
/**
 * The internal dependencies.
 */
import globalResets from '../../common/global-resets';
import PrivateRoute from '../../containers/private-route';
import LoginPage from '../../pages/login';
import ForgotPasswordPage from '../../pages/forgot-password';
import HomePage from '../../pages/home';
import DashboardPage from '../../pages/dashboard';
import {authReceiveLogin} from '../../store/auth/actions';
import {authCheckLogin} from "../../store/auth/actions";

class Application extends React.Component {


    async componentDidMount() {

        const {authCheckLogin} = this.props;
        authCheckLogin();

        /*await callRoute(['checkLogin']).then((response) => {

            if (response.status == 200) {
                response.data.fullname = response.data.firstname + " " + response.data.lastname;
                store.dispatch(this.props.authReceiveLogin(response.data));
                callRoute(['getTasksWorkSteps']).then((response) => {
                    store.dispatch(tasksWorkStepsReceive(response.data._embedded ? response.data._embedded.workstep : null));
                });

            }
        });*/

    }


    render() {
        globalResets();

        return (
            <Router>
                <Switch>
                    <Route path="/login" component={LoginPage}/>
                    <Route path="/forgot-password" component={ForgotPasswordPage}/>
                    <PrivateRoute path="/dashboard/*" component={DashboardPage}/>
                    <PrivateRoute path="/" component={HomePage}/>
                </Switch>
            </Router>
        );

    }
}

//export default Application;
export default connect(
    () => ({
        authReceiveLogin,
        authCheckLogin
    })
)(Application);



// WEBPACK FOOTER //
// ./src/containers/application/index.js